import { useRef } from "react";
import { IoMdMail } from "react-icons/io";
import { FaPhone } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";

const Header = () => {
  const navbarRef = useRef(null);
  const buttonRef = useRef(null);
  const { page } = useParams();
  const navigate = useNavigate();
  const handleScroll = (elementDiv: any) => {
    const element = document.getElementById(elementDiv);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // 'auto' for instant scroll
    }
    hideShowMenu();
    navigate(`/${elementDiv}`);
  };

  const hideShowMenu = () => {
    const navbar = navbarRef.current;
    const button = buttonRef.current;
    if (navbar?.classList.contains("show")) {
      navbar.classList.remove("show");
    }
    if (!button?.classList.contains("collapsed")) {
      button.classList.add("collapsed");
    }
  };

  return (
    <div id="home">
      <div className="top-bar">
        <div className="section">
          <div className="d-flex align-items-center gap-2">
            <IoMdMail
              className="icon"
              style={{ marginTop: "1px" }}
              size={16}
            ></IoMdMail>
            <span className="email"><a href="mailto:service@abmpropertymgmt.com">service@abmpropertymgmt.com</a></span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <FaPhone color="white" size={14} />
            <span className="mobile-number"><a href="tel:18055220292">(805) 522-0292</a></span>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="section">
          <div className="logo-section">
            <div className="logo nav-brand">
              <img src="/assets/img/abm.png" alt="ABM Logo" />
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              ref={buttonRef}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
            ref={navbarRef}
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a
                  className={`nav-link ${page === "home" && "active"}`}
                  onClick={() => {
                    handleScroll("home");
                  }}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${page === "about-us" && "active"}`}
                  onClick={() => {
                    handleScroll("about-us");
                  }}
                >
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${page === "home-owner-portal" && "active"
                    }`}
                  onClick={() => {
                    window.open('https://portal.abmpropertymgmt.com/login', '_blank');
                  }}
                >
                  Homeowner Portal
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${page === "management-service" && "active"
                    }`}
                  onClick={() => {
                    handleScroll("management-service");
                  }}
                >
                  Management Services
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${page === "contact-us" && "active"}`}
                  onClick={() => {
                    handleScroll("contact-us");
                  }}
                >
                  Contact Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${page === "helpful-link" && "active"}`}
                  onClick={() => {
                    handleScroll("helpful-link");
                  }}
                >
                  Helpful Links
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};
export default Header;
